import './Stammdaten.css';
import '../Tabellen/Tabellenstyle.css';
import React, { useEffect, useState } from 'react';
import Menu from '../Menubar/Menu';
import BhfLaden from '../Bahnhof/BhfLaden';
import EiuLaden from '../Eiu/EiuLaden';
import EvuLaden from '../Evu/EvuLaden';
import KreisLaden from '../Kreis/KreisLaden';
import StreckenkatLaden from '../Streckenkategorie/StreckenkatLaden';
import VvLaden from '../Verkehrsvertrag/VvLaden';
import ZvLaden from '../Zweckverband/ZvLaden';
import { Route, Routes, useLocation, useNavigate } from 'react-router';
import { sdTabellenCollectionEbeneDrei, sdTabellenCollectionEbeneEins, sdTabellenCollectionEbeneZwei } from '../../constants/const';
import VvLinieProdukt from '../VvLinieProdukt/VvLinieProdukt';
import { Categories, EbeneH3, EbeneInhalt, SpecificTable, TableOptionsAndView } from '../MainMenu/MenüSicht';
import AbschnittLaden from '../Abschnitte/AbschnittLaden';
import { Linien } from '../Linien/Linien';
import { Linienführung } from '../Linienführung/Linienführung';
import Streckenverlauf from '../Infrastruktur/Streckenverlauf';
import StreckeBasedOn from '../Infrastruktur/StreckenverlaufBasedOnPrevious';
import NeueLinienführung from '../Linienführung/NeueLinienführung/NeueLinienführung';

var MonitorApi = require('monitor-api');

export default function Stammdaten({ myApiClient, setSection }) {
  //lädt die Stammdatenübersicht

  // a
  var absInstance = new MonitorApi.AbschnittApi(myApiClient);
  // b
  var bhfInstance = new MonitorApi.BahnhofApi(myApiClient);
  var bhfKatInstance = new MonitorApi.BahnhofkategorieApi(myApiClient);
  var bhfTypInstance = new MonitorApi.BahnhoftypApi(myApiClient);
  // e
  var eiuInstance = new MonitorApi.EisenbahninfraunternehmenApi(myApiClient);
  var evuInstance = new MonitorApi.EisenbahnverkehrsunternehmenApi(myApiClient);
  // i
  var infraInstance = new MonitorApi.LinienverlaufApi(myApiClient);
  // k
  var kreisInstance = new MonitorApi.KreisApi(myApiClient);
  // l
  var landInstance = new MonitorApi.LandApi(myApiClient);
  var linieInstance = new MonitorApi.LinieApi(myApiClient);
  var linienVerlInstance = new MonitorApi.LinienverlaufApi(myApiClient);
  // p
  var produktInstance = new MonitorApi.ProduktApi(myApiClient);
  // s
  var strInstance = new MonitorApi.StreckeApi(myApiClient);
  var strKatInstance = new MonitorApi.StreckenkategorieApi(myApiClient);
  var strVerlInstance = new MonitorApi.StreckenverlaufApi(myApiClient);
  // t
  var tgZuJahrInstance = new MonitorApi.TagesgruppeZuJahrApi(myApiClient);
  // v
  var vlpInstance = new MonitorApi.VertraglinieproduktApi(myApiClient);
  var vmInstance = new MonitorApi.VerkehrsmittelApi(myApiClient);
  var vvInstance = new MonitorApi.VerkehrsvertragApi(myApiClient);
  var vvArtInstance = new MonitorApi.VerkehrsvertragsartApi(myApiClient);
  // z
  var zvInstance = new MonitorApi.ZweckverbandApi(myApiClient);

  useEffect(() => {
    setSection('Stammdaten');
  }, [setSection]);

  const navigate = useNavigate();
  const history = useLocation();
  const [table, setTable] = useState();
  const [showMenue, setShowMenue] = useState(true);

  const goBack = () => {
    navigate(`../stammdaten`, { replace: true });
  }

  const chooseTable = event => {
    event.preventDefault();
    setTable(event.target.value);
    navigate(`../stammdaten/${event.target.value}`, { replace: true });
  }

  useEffect(() => {
    const steps = history.pathname.split('/');
    if (steps[steps.length - 1] !== "stammdaten") {
      console.log('gibt eine Weiterleitung!')
      setTable(steps[steps.length - 1]);
    }

  }, [history]);

  const swapShowing = event => {
    event.preventDefault();
    setShowMenue(!showMenue);
  }

  return (
    <div className="next-to-menu">
      <Menu />
      <TableOptionsAndView>
        <Categories>
            <button onClick={swapShowing}>
              {showMenue ? "Menü verbergen" : "Menü zeigen"}
            </button>
          {showMenue && <> 
          <EbeneH3>Ebene Eins</EbeneH3>
          {sdTabellenCollectionEbeneEins.map(tab => {
            return (
              <EbeneInhalt
                color="red"
                key={tab.kurz}
                chosen={table === tab.kurz ? tab.kurz : undefined}
                value={tab.kurz} onClick={chooseTable}>{tab.header}
              </EbeneInhalt>
            )
          })}
          <EbeneH3>Ebene Zwei</EbeneH3>
          {sdTabellenCollectionEbeneZwei.map(tab => {
            return (
              <EbeneInhalt
                color="green"
                key={tab.kurz}
                chosen={table === tab.kurz ? tab.kurz : undefined}
                value={tab.kurz} onClick={chooseTable}>{tab.header}</EbeneInhalt>
            )
          })}
          <EbeneH3>Ebene Drei</EbeneH3>
          {sdTabellenCollectionEbeneDrei.map(tab => {
            return (
              <EbeneInhalt
                color="purple"
                key={tab.kurz}
                chosen={table === tab.kurz ? tab.kurz : undefined}
                value={tab.kurz} onClick={chooseTable}>{tab.header}</EbeneInhalt>
            )
          })}
          </>}
        </Categories>

        <SpecificTable>
          <Routes>
            <Route path='/*' element={<FollowingRoutes
              goBack={goBack}
              absInstance={absInstance}
              bhfInstance={bhfInstance}
              bhfKatInstance={bhfKatInstance}
              bhfTypInstance={bhfTypInstance}
              zvInstance={zvInstance}
              setTable={setTable}
              eiuInstance={eiuInstance}
              evuInstance={evuInstance}
              kreisInstance={kreisInstance}
              landInstance={landInstance}
              vvInstance={vvInstance}
              strKatInstance={strKatInstance}
              vvArtInstance={vvArtInstance}
              linieInstance={linieInstance}
              produktInstance={produktInstance}
              vlpInstance={vlpInstance}
              vmInstance={vmInstance}
              infraInstance={infraInstance}
              tgZuJahrInstance={tgZuJahrInstance}
              strVerlInstance={strVerlInstance}
              strInstance={strInstance} 
              linienVerlInstance={linienVerlInstance}/>}
            />
          </Routes>
        </SpecificTable>
      </TableOptionsAndView>
    </div>
  )
}

function FollowingRoutes({
  goBack,
  absInstance,
  bhfInstance,
  bhfKatInstance,
  bhfTypInstance,
  zvInstance,
  setTable,
  eiuInstance,
  evuInstance,
  kreisInstance,
  landInstance,
  vvInstance,
  strKatInstance,
  vvArtInstance,
  linieInstance,
  produktInstance,
  vlpInstance,
  vmInstance,
  infraInstance,
  tgZuJahrInstance,
  strVerlInstance,
  strInstance,
  linienVerlInstance
}) {
  return (
    <Routes>
      <Route path={'/eiu'} element={<EiuLaden
        instance={eiuInstance}
        setTable={setTable}
        goBack={goBack} />}
      />
      <Route path={'/evu'} element={<EvuLaden
        instance={evuInstance}
        setTable={setTable}
        goBack={goBack} />}
      />
      <Route path={'/kreis'} element={<KreisLaden
        instance={kreisInstance}
        landInstance={landInstance}
        setTable={setTable}
        goBack={goBack} />}
      />
      <Route path={'/linie'} element={<Linien
        instance={linieInstance}
        vmInstance={vmInstance}
        setTable={setTable}
        goBack={goBack}
        bhfInstance={bhfInstance}
        strVerlInstance={strVerlInstance}
        strInstance={strInstance} />}
      />
      <Route path={'/strkat'} element={<StreckenkatLaden
        instance={strKatInstance}
        setTable={setTable}
        goBack={goBack} />}
      />
      <Route path={'/abs'} element={<AbschnittLaden
        absInstance={absInstance}
        bhfInstance={bhfInstance}
        kreisInstance={kreisInstance}
        zvInstance={zvInstance}
        eiuInstance={eiuInstance}
        strKatInstance={strKatInstance}
        setTable={setTable}
        goBack={goBack} />}
      />
      <Route path={'/bhf'} element={<BhfLaden
        instance={bhfInstance}
        katInstance={bhfKatInstance}
        typInstance={bhfTypInstance}
        zvInstance={zvInstance}
        setTable={setTable}
        goBack={goBack} />}
      />
      <Route path={'/infra'} element={< Streckenverlauf
        strVerlInstance={strVerlInstance}
        bhfInstance={bhfInstance}
        strInstance={strInstance}
        absInstance={absInstance}
        setTable={setTable}
        goBack={goBack} />}
      />

      <Route path={'/infra-basedOn'} element={<StreckeBasedOn 
      strInstance={strInstance}
      strVerlInstance={strVerlInstance} 
      bhfInstance={bhfInstance} />}
      />
      <Route path={'/vertrag'} element={<VvLaden
        vvInstance={vvInstance}
        vvArtInstance={vvArtInstance}
        evuInstance={evuInstance}
        zvInstance={zvInstance}
        setTable={setTable}
        goBack={goBack} />}
      />
      <Route path={'/verband'} element={<ZvLaden
        instance={zvInstance}
        setTable={setTable}
        goBack={goBack} />}
      />
      <Route path={`/linienfuehrung`} element={<Linienführung
        linienInstance={linieInstance}
        jahrInstance={tgZuJahrInstance}
        linienVerlInstance={infraInstance}
        setTable={setTable}
        goBack={goBack} />}
      />
      <Route path={`/linienführung-anlegen`} element={<NeueLinienführung
        linienInstance={linieInstance}
        linienVerlInstance={linienVerlInstance}
        bhfInstance={bhfInstance}
        strVerlInstance={strVerlInstance}
        strInstance={strInstance} />}
      />

      <Route path={'/vertraglinieprodukt'} element={<VvLinieProdukt
        vvInstance={vvInstance}
        linieInstance={linieInstance}
        prodInstance={produktInstance}
        vvLinProdInstance={vlpInstance}
        setTable={setTable}
        goBack={goBack} />}
      />
    </Routes>
  )
}